import { createReducer } from "../../../common/reduxUtil";
import {
  SAT_SET_CATALOG,
  SAT_SET_LOAD_ERROR,
  SAT_CATALOG_REQUESTED,
  SAT_SET_ATTEMPT_STARTING,
  SAT_MARK_LESSON_COMPLETE,
} from "./types";

const initialState = {
  catalog: null,
  loadError: "",
  request: 0,
  attemptStarting: false,
};

export default createReducer(initialState, {
  [SAT_SET_CATALOG]: (state, catalog) => ({ ...state, catalog }),
  [SAT_SET_LOAD_ERROR]: (state, loadError) => ({ ...state, loadError }),
  [SAT_CATALOG_REQUESTED]: (state) => ({
    ...state,
    request: state.request + 1,
  }),
  [SAT_SET_ATTEMPT_STARTING]: (state, attemptStarting) => ({
    ...state,
    attemptStarting,
  }),
  // Only the catalogue the lesson was read in; a newer bundle keeps its own progress.
  [SAT_MARK_LESSON_COMPLETE]: (state, { id, bundleId }) =>
    state.catalog?.bundleId === bundleId
      ? {
          ...state,
          catalog: {
            ...state.catalog,
            lessons: state.catalog.lessons.map((lesson) =>
              lesson.id === id ? { ...lesson, completed: true } : lesson
            ),
          },
        }
      : state,
});
